import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#1A1A1A] text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="container-luxury py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_visa-business/artifacts/6dls0pvg_logo%20full%20excelsium.jpg" 
                alt="Excelsium Conseils" 
                className="h-28 w-auto"
              />
            </Link>
            <p className="text-white/60 text-sm leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          {/* Particuliers */}
          <div>
            <h4 className="font-serif text-lg text-[#C9A227] mb-6">{t('footer.particuliers')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/particuliers" className="footer-link flex items-center gap-2 text-sm" data-testid="footer-visa-schengen">
                  <ArrowRight className="w-4 h-4" />
                  {t('footer.visaSchengen')}
                </Link>
              </li>
              <li>
                <Link to="/particuliers" className="footer-link flex items-center gap-2 text-sm" data-testid="footer-visa-canada">
                  <ArrowRight className="w-4 h-4" />
                  {t('footer.visaCanada')}
                </Link>
              </li>
              <li>
                <Link to="/particuliers" className="footer-link flex items-center gap-2 text-sm" data-testid="footer-gestion-immobiliere">
                  <ArrowRight className="w-4 h-4" />
                  {t('footer.gestionImmo')}
                </Link>
              </li>
              <li>
                <Link to="/particuliers" className="footer-link flex items-center gap-2 text-sm" data-testid="footer-maitrise-oeuvre">
                  <ArrowRight className="w-4 h-4" />
                  {t('footer.maitriseOeuvre')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Professionnels */}
          <div>
            <h4 className="font-serif text-lg text-[#C9A227] mb-6">{t('footer.professionnels')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/professionnels" className="footer-link flex items-center gap-2 text-sm" data-testid="footer-strategie">
                  <ArrowRight className="w-4 h-4" />
                  {t('footer.strategie')}
                </Link>
              </li>
              <li>
                <Link to="/professionnels" className="footer-link flex items-center gap-2 text-sm" data-testid="footer-formation">
                  <ArrowRight className="w-4 h-4" />
                  {t('footer.formations')}
                </Link>
              </li>
              <li>
                <Link to="/professionnels" className="footer-link flex items-center gap-2 text-sm" data-testid="footer-hygiene">
                  <ArrowRight className="w-4 h-4" />
                  {t('footer.hygiene')}
                </Link>
              </li>
              <li>
                <Link to="/professionnels" className="footer-link flex items-center gap-2 text-sm" data-testid="footer-client-mystere">
                  <ArrowRight className="w-4 h-4" />
                  {t('footer.clientMystere')}
                </Link>
              </li>
              <li>
                <Link to="/professionnels" className="footer-link flex items-center gap-2 text-sm" data-testid="footer-marketing-digital">
                  <ArrowRight className="w-4 h-4" />
                  {t('footer.marketing')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-lg text-[#C9A227] mb-6">{t('footer.contact')}</h4>
            <ul className="space-y-4">
              <li>
                <a href="tel:+21696050699" className="footer-link flex items-start gap-3 text-sm" data-testid="footer-phone">
                  <Phone className="w-5 h-5 text-[#C9A227] flex-shrink-0 mt-0.5" />
                  <span>+216 96 050 699</span>
                </a>
              </li>
              <li>
                <a href="mailto:commercial@excelsium.online" className="footer-link flex items-start gap-3 text-sm" data-testid="footer-email">
                  <Mail className="w-5 h-5 text-[#C9A227] flex-shrink-0 mt-0.5" />
                  <span>commercial@excelsium.online</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-sm text-white/60">
                  <MapPin className="w-5 h-5 text-[#C9A227] flex-shrink-0 mt-0.5" />
                  <span>Excelsium Conseils<br />Pacha Centre - Montplaisir<br />Tunis</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Tax Notice */}
      <div className="border-t border-white/10 bg-[#1A1A1A]">
        <div className="container-luxury py-3">
          <p className="text-center text-white/40 text-xs" data-testid="footer-tax-notice">
            {t('footer.taxNotice')}
          </p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container-luxury py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/50">
            <p>© {new Date().getFullYear()} Excelsium Conseils. {t('footer.rights')}</p>
            <div className="flex gap-6">
              <Link to="/mentions-legales" className="hover:text-[#C9A227] transition-colors" data-testid="footer-mentions">
                {t('footer.legal')}
              </Link>
              <Link to="/politique-confidentialite" className="hover:text-[#C9A227] transition-colors" data-testid="footer-confidentialite">
                {t('footer.privacy')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
